import React, { useEffect, useRef, useState } from 'react';
import './WelcomePage.css';
import companylogo from "./asset/companylogo.png";
// import emailjs from 'emailjs-com';
import emailjs from "@emailjs/browser";



const CONTACT_NUMBER = '+91-63941 65416';

const WelcomePage = () => {
  // const [theme, setTheme] = useState('light');
  const theme = useState('light');
  const [activeProduct, setActiveProduct] = useState(null);

  const products = [
    {
      id: 1,
      name: 'GI Earthing Electrode',
      image: 'https://www.investopedia.com/thmb/Bmo4lJrnc63UKSFBWleV0uq7i9k=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/SamplingError-4189704-Final-533c7191287b4b0e89fb11873679e08c.jpg',
      description: 'Robust, hot-dip galvanized iron electrodes engineered for stable and low-maintenance earthing.',
      specs: ['IS/IEC compliant design', 'Corrosion-resistant coating', 'Ideal for industrial & commercial sites'],
      priceNote: 'Talk to our team for project-wise pricing',
    },
    {
      id: 2,
      name: 'Copper Bonded Rod',
      image: 'https://alphashooters.b-cdn.net/wp-content/uploads/2019/04/sony-a6400-sample-image-butterfly-DSC07365.jpg',
      description: 'High-conductivity copper bonded rods that ensure consistently low resistance over the lifecycle.',
      specs: ['Premium copper bonding', 'Low earth resistance', 'Long service life in harsh soils'],
      priceNote: 'Optimised pricing for bulk and repeated orders',
    },
    {
      id: 3,
      name: 'Earth Pit & Inspection Chamber',
      image: 'https://dtz3um9jw7ngl.cloudfront.net/blog/content/sony-a6400-review/tripod-mounted-sony-a6400-camera.jpg',
      description: 'Weatherproof inspection chambers for safe access and testing of your earthing network.',
      specs: ['Heavy-duty polymer body', 'UV & weather resistant', 'Easy inspection and maintenance'],
      priceNote: 'Available in multiple load-bearing classes',
    },
    {
      id: 4,
      name: 'Earthing Strips & Conductors',
      image: 'https://static.scientificamerican.com/dam/m/755f74e2a406e336/original/perseverance_mars_rover_selfie_with_sample_tubes.jpg?m=1736373598.756&w=600',
      description: 'Copper and GI strips, tapes and wires to create reliable equipotential bonding paths.',
      specs: ['Copper & GI variants', 'Wide range of sizes', 'Excellent current carrying capacity'],
      priceNote: 'Cut-to-length and customised options on request',
    },
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Rahul Mehta',
      role: 'Electrical Contractor, Mumbai',
      quote:
        'GroundSafe earthing kits are consistent, easy to install and well documented. Our test readings have been very stable.',
      image:
        'https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=200',
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Project Manager – Process Plant',
      quote:
        'From design support to deliveries at site, the team understands project realities and helps us close work on schedule.',
      image:
        'https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&w=200',
    },
    {
      id: 3,
      name: 'Global Infra Engineers',
      role: 'EPC Company',
      quote:
        'Reliable products, transparent documentation and responsive coordination make GroundSafe a strong long-term partner.',
      image:
        'https://images.pexels.com/photos/1181524/pexels-photo-1181524.jpeg?auto=compress&cs=tinysrgb&w=200',
    }, 
    {
      id: 4,
      name: 'Priya Sharma',
      role: 'Project Manager – Process Plant',
      quote:
        'From design support to deliveries at site, the team understands project realities and helps us close work on schedule.',
      image:
        'https://images.pexels.com/photos/1181519/pexels-photo-1181519.jpeg?auto=compress&cs=tinysrgb&w=200',
    },
    {
      id: 5,
      name: 'Global Infra Engineers',
      role: 'EPC Company',
      quote:
        'Reliable products, transparent documentation and responsive coordination make GroundSafe a strong long-term partner.',
      image:
        'https://images.pexels.com/photos/1181524/pexels-photo-1181524.jpeg?auto=compress&cs=tinysrgb&w=200',
    },
  ];

  const testimonialsRef = useRef(null);

  useEffect(() => {
    const container = testimonialsRef.current;
    if (!container) return;

    const speed = 0.6; // pixels per tick - gentle continuous motion
    const intervalMs = 16; // ~60fps, smoother animation

    const id = window.setInterval(() => {
      const { scrollLeft, scrollWidth } = container;
      const loopWidth = scrollWidth / 2; // because we render the list twice

      if (scrollLeft >= loopWidth) {
        container.scrollLeft = scrollLeft - loopWidth;
      } else {
        container.scrollLeft = scrollLeft + speed;
      }
    }, intervalMs);

    return () => {
      window.clearInterval(id);
    };
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    message: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'success') => {
    const toastData = { message, type, show: true };
    setToast(toastData);
    
    setTimeout(() => {
      setToast({ ...toastData, show: false });
      setTimeout(() => {
        setToast(null);
      }, 300);
    }, 3000);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    
    // Only allow numeric characters for phone field (max 10 digits)
    if (id === 'phone') {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prev) => ({ ...prev, [id]: numericValue }));
      setFormErrors((prev) => ({ ...prev, [id]: '' }));
    } else {
      setFormData((prev) => ({ ...prev, [id]: value }));
      setFormErrors((prev) => ({ ...prev, [id]: '' }));
    }
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  const errors = {};

  if (!formData.name.trim()) {
    errors.name = 'Please enter your name.';
  }

  if (!formData.company.trim()) {
    errors.company = 'Please enter your company name.';
  }

  if (!formData.email.trim()) {
    errors.email = 'Please enter your email.';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
    errors.email = 'Please enter a valid email address.';
  }

  if (!formData.phone.trim()) {
    errors.phone = 'Please enter your mobile number.';
  } else {
    const digits = formData.phone.replace(/\D/g, '');
    const lastTen = digits.slice(-10);

    if (lastTen.length !== 10 || !/^[6-9][0-9]{9}$/.test(lastTen)) {
      errors.phone = 'Please enter a valid 10-digit Indian mobile number.';
    }
  }

  if (!formData.message.trim()) {
    errors.message = 'Please provide a short description of your project.';
  }

  setFormErrors(errors);

  if (Object.keys(errors).length > 0) {
    return;
  }

  /* ✅ EmailJS payload */
  const templateParams = {
    name: formData.name,
    company: formData.company,
    email: formData.email,
    time: Date.now,
    phone: formData.phone,
    message: formData.message,
  };

  emailjs
    .send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY 
    )
    .then(() => {
      showToast('Thank you! Your quote request has been sent successfully.');
      setFormData({
        name: '',
        company: '',
        email: '',
        phone: '',
        message: '',
      });
    })
    .catch(() => {
      showToast('Something went wrong. Please try again later.');
    });
};

  // const toggleTheme = () => {
  //   setTheme((prev) => (prev === 'light' ? 'dark' : 'light'));
  // };

  const handleScrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className={`welcome-root ${theme}`}>
      <header className="site-header">
        {/* <img id='company-logo' src={companylogo} alt="Company Logo" /> */}
        <div className="logo">Kedar Earthing Solution</div>
        <nav className="nav-links">
          <button onClick={() => handleScrollTo('hero')} className="nav-link">
            Home
          </button>
          <button onClick={() => handleScrollTo('products')} className="nav-link">
            Products
          </button>
          <button onClick={() => handleScrollTo('contact')} className="nav-link">
            Contact
          </button>
        </nav>
        <div className="header-actions">
          {/* <button  className="secondary-btn small " onClick={toggleTheme}>
            {theme === 'light' ? 'Dark' : 'Light'} Mode
          </button> */}
          <a
            href={`tel:${CONTACT_NUMBER.replace(/\s/g, '')}`}
            className="header-phone"
          >
            {CONTACT_NUMBER}
          </a>
          <button
            className="primary-btn header-cta"
            onClick={() => handleScrollTo('contact')}
          >
            Request a Quote
          </button>
        </div>
      </header>

      <main className="page-content">
        {/* <section id="hero" className="hero-section">
          <div className="hero-content">
            <p className="hero-kicker">Specialists in Electrical Earthing</p>
            <h1>Safe, Reliable Earthing for Every Project</h1>
            <p className="hero-subtitle">
              We design and supply complete earthing systems that protect
              people, equipment and infrastructure across industrial,
              commercial and residential sites.
            </p>
            <p className="hero-contact-highlight">
              Call us at
              {' '}
              <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, '')}`}>
                {CONTACT_NUMBER}
              </a>
              {' '}
              for immediate project support.
            </p>
            <div className="hero-actions">
              <button
                className="primary-btn large"
                onClick={() => handleScrollTo('products')}
              >
                Explore Products
              </button>
              <button
                className="secondary-btn large"
                onClick={() => handleScrollTo('contact')}
              >
                Request a Quote
              </button>
            </div>
          </div>
          <div className="hero-image" aria-hidden="true">
            <div className="hero-gradient" />
            <div className="hero-card">
              <p>Designed for</p>
              <h3>Low-Resistance, Safe Earthing</h3>
              <ul>
                <li>Substations & switchyards</li>
                <li>Factories & warehouses</li>
                <li>Commercial & residential towers</li>
              </ul>
            </div>
          </div>
        </section> */}
<section id="hero" className="hero-section">
  <div className="hero-content">
    <p className="hero-kicker">India’s Trusted Electrical Earthing Experts</p>

    <h1>High-Quality Earthing Solutions for Maximum Safety</h1>

    <p className="hero-subtitle">
      We manufacture and supply reliable earthing systems including chemical
      earthing, copper bonded rods, GI electrodes, earthing strips, and
      lightning protection systems. Our solutions ensure low-resistance and
      long-lasting grounding for industries, homes and commercial buildings
      across India.
    </p>

    <p className="hero-contact-highlight">
      Need urgent assistance? Call us at{' '}
      <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, '')}`}>
        {CONTACT_NUMBER}
      </a>{' '}
      for expert support.
    </p>

    <div className="hero-actions">
      <button
        className="primary-btn large"
        onClick={() => handleScrollTo('products')}
      >
        View Our Earthing Products
      </button>
      <button
        className="secondary-btn large"
        onClick={() => handleScrollTo('contact')}
      >
        Get Free Quote
      </button>
    </div>
  </div>

  <div className="hero-image" aria-hidden="true">
    <div className="hero-gradient" />
    <div className="hero-card">
      <p>Perfect For</p>
      <h3>Low-Resistance, Maintenance-Free Earthing</h3>

      <ul>
        <li>Industrial plants & substations</li>
        <li>Factories, warehouses & data centers</li>
        <li>Residential & commercial buildings</li>
        <li>Solar installations & telecom towers</li>
      </ul>
    </div>
  </div>
</section>

        <section id="products" className="products-section">
          <div className="section-header">
            <h2>Electrical Earthing Products</h2>
            <p>
              Certified components that help you achieve low, repeatable earth
              resistance and safer fault current dissipation.
            </p>
          </div>

          <div className="products-grid">
            {products.map((product) => (
              <article key={product.id} className="product-card">
                <div className="product-image-wrapper">
                  <img src={product.image} alt={product.name} />
                </div>
                <div className="product-body">
                  <h3>{product.name}</h3>
                  <p className="product-description">{product.description}</p>
                  <ul className="product-specs">
                    {product.specs.map((spec) => (
                      <li key={spec}>{spec}</li>
                    ))}
                  </ul>
                </div>
                <div className="product-footer">
                  <span className="price-note">{product.priceNote}</span>
                  <button
                    className="primary-btn small"
                    onClick={() => setActiveProduct(product)}
                  >
                    Learn More
                  </button>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section id="testimonials" className="testimonials-section">
          <div className="section-header">
            <h2>Trusted by Electrical Professionals</h2>
            <p>
              Contractors, EPCs and industrial customers rely on Kedar Earthing Solution for
              reliable, repeatable earthing performance.
            </p>
          </div>
          <div className="testimonials-grid" ref={testimonialsRef}>
            {[...testimonials, ...testimonials].map((t, index) => (
              <article
                key={`${t.id}-${index}`}
                className="testimonial-card"
              >
                <div className="testimonial-badge">★ Verified Client</div>
                <div className="testimonial-header">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="testimonial-avatar"
                  />
                  <div>
                    <p className="testimonial-name">{t.name}</p>
                    <p className="testimonial-role">{t.role}</p>
                  </div>
                </div>
                <p className="testimonial-quote">“{t.quote}”</p>
              </article>
            ))}
          </div>
        </section>

        <section id="contact" className="contact-section">
          <div className="section-header">
            <h2>Request a Project Quote</h2>
            <p>
              Share a few project details and our team will get back to you with
              a tailored earthing solution and bill of material.
            </p>
          </div>
          <div className="contact-layout">
            <div className="contact-visual" aria-hidden="true">
              <div className="contact-visual-card">
                <p className="contact-visual-kicker">Quick project quotes</p>
                <h3>Get Fast Earthing Project Quotes – PAN India</h3>
                <p className="contact-visual-text">
                  Submit your site details and receive a code-compliant earthing solution for plants, switchyards and buildings.
                </p>
                <p className="contact-visual-call">
                  Prefer to talk?
                  {' '}
                  <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, '')}`}>
                    Call {CONTACT_NUMBER}
                  </a>
                  {' '}
                  to speak with our earthing experts today.
                </p>
              </div>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  {/* <label htmlFor="name">Name</label> */}
                  <input
                    id="name"
                    type="text"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleInputChange}
                    aria-invalid={!!formErrors.name}
                  />
                  {formErrors.name && (
                    <p className="form-error">{formErrors.name}</p>
                  )}
                </div>
                <div className="form-field">
                  {/* <label htmlFor="company">Company</label> */}
                  <input
                    id="company"
                    type="text"
                    placeholder="Company name"
                    value={formData.company}
                    onChange={handleInputChange}
                    aria-invalid={!!formErrors.company}
                  />
                  {formErrors.company && (
                    <p className="form-error">{formErrors.company}</p>
                  )}
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  {/* <label htmlFor="email">Email</label> */}
                  <input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleInputChange}
                    aria-invalid={!!formErrors.email}
                  />
                  {formErrors.email && (
                    <p className="form-error">{formErrors.email}</p>
                  )}
                </div>
                <div className="form-field">
                  {/* <label htmlFor="phone">Phone</label> */}
                  <input
                    id="phone"
                    type="tel"
                    placeholder="Contact number"
                    value={formData.phone}
                    onChange={handleInputChange}
                    aria-invalid={!!formErrors.phone}
                  />
                  {formErrors.phone && (
                    <p className="form-error">{formErrors.phone}</p>
                  )}
                </div>
              </div>
              <div className="form-field">
                {/* <label htmlFor="message">Project Details</label> */}
                <textarea
                  id="message"
                  rows={3}
                  placeholder="Briefly describe your earthing requirement"
                  value={formData.message}
                  onChange={handleInputChange}
                  aria-invalid={!!formErrors.message}
                />
                {formErrors.message && (
                  <p className="form-error">{formErrors.message}</p>
                )}
              </div>
              <button type="submit" className="primary-btn large full-width">
                Submit Request
              </button>
            </form>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div className="footer-main">
          <div className="footer-brand">
            <img src={companylogo} alt="Kedar Earthing Solution Logo" className="footer-logo"/>
            <div className="logo">Kedar Earthing Solution</div>
            <p className="footer-slogan">Trusted Quality in Electrical Earthing Solutions.</p>
            <p>
              Kedar Earthing Solutions Pvt. Ltd.
              <br />
              1165, New Patel Nagar ,Jalaun Road, Orai(Jalaun), UP 285001
              <br />
              GST: 09AXBPB8882F1ZC · UAM: UP37C0002739
            </p>
            <p className="footer-contact">
              Call us:
              {' '}
              <a href={`tel:${CONTACT_NUMBER.replace(/\s/g, '')}`}>
                {CONTACT_NUMBER}
              </a>
            </p>
          </div>
          <div className="footer-links">
            <div>
              <h4>Company</h4>
              <a href="#hero">About</a>
              <a href="#products">Products</a>
              <a href="#testimonials">Testimonials</a>
            </div>
            <div>
              <h4>Support</h4>
              <a href="#contact">Request a Quote</a>
              <a href="#contact">Contact</a>
            </div>
            <div>
              <h4>Connect</h4>
              <div className="social-row">
                <a href="https://www.linkedin.com/company/kedar-earthing-solution/" aria-label="LinkedIn" className="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="4" />
                    <path d="M8 17V10" />
                    <circle cx="8" cy="8" r="1" />
                    <path d="M12 17V13.3C12 11.8 13 11 14.2 11C15.4 11 16 11.8 16 13.3V17" />
                  </svg>
                </a>
                {/* <a href="#" aria-label="Facebook" className="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="4" />
                    <path d="M13 18V13.5H15L15.5 11H13V9.5C13 9 13.2 8.5 14.1 8.5H15.5V6.5H13.4C11.4 6.5 10.5 7.7 10.5 9.5V11H9V13.5H10.5V18H13Z" />
                  </svg>
                </a> */}
                <a href="https://youtube.com/@kedarearthingsolution?si=YfXN5jPljF5CQ5Xm" aria-label="YouTube" className="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="3" y="6" width="18" height="12" rx="3" />
                    <path d="M11 10L15 12L11 14V10Z" />
                  </svg>
                </a>
                <a href="https://x.com/KedarEarthing?s=20" aria-label="Twitter" className="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
                    <path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Kedar Earthing Solution. All rights reserved.</p>
          <button
            type="button"
            className="back-to-top"
            onClick={() => handleScrollTo('hero')}
          >
            Back to top ↑
          </button>
        </div>
      </footer>

      {activeProduct && (
        <div className="modal-backdrop" onClick={() => setActiveProduct(null)}>
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button
              className="modal-close"
              type="button"
              onClick={() => setActiveProduct(null)}
            >
              ×
            </button>
            <h3>{activeProduct.name}</h3>
            <p className="product-description">{activeProduct.description}</p>
            <ul className="product-specs">
              {activeProduct.specs.map((spec) => (
                <li key={spec}>{spec}</li>
              ))}
            </ul>
            <p className="price-note">{activeProduct.priceNote}</p>
            <button
              className="primary-btn full-width"
              type="button"
              onClick={() => {
                setActiveProduct(null);
                handleScrollTo('contact');
              }}
            >
              Enquire Now
            </button>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {toast && (
        <div className={`toast ${toast.show ? 'show' : ''} ${toast.type}`}>
          <div className="toast-content">
            <span className="toast-icon">✓</span>
            <span className="toast-message">{toast.message}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default WelcomePage;
